<script>
    import { navigationStore } from '../../../stores/navigationStore';
    
    let isOpen = false;
    
    // Subscribe to navigation store
    navigationStore.subscribe(state => {
        isOpen = state.isOpen;
    });
    
    function handleToggle() {
        console.log('[NavigationToggle] Button clicked, current state:', isOpen);
        navigationStore.toggle();
    }
</script>

<button
    class="toolbar-button spec-button navigation-toggle"
    class:active={isOpen}
    on:click={handleToggle}
    title={isOpen ? 'Close spec outline (Ctrl+Shift+O)' : 'Open spec outline (Ctrl+Shift+O)'}
    aria-label={isOpen ? 'Close spec outline' : 'Open spec outline'}
    aria-pressed={isOpen}
    data-navigation-toggle
    data-testid="navigation-toggle-button"
>
    <i class="fas fa-list-alt"></i>
    <span class="button-text">Outline</span>
</button>

<style>
    /* The navigation-toggle class is only for specific overrides since we're using toolbar-button spec-button */

    /* Hide button text early - before other spec buttons */
    @media (width <= 2000px) {
        .button-text {
            display: none !important;
        }
        
        button {
            width: var(--height-toolbar-button) !important;
            min-width: var(--height-toolbar-button) !important;
            padding: 0 !important;
            border-radius: 50% !important;
        }
    }

    /* Active state should match the hover state for better visibility */
    .navigation-toggle.active {
        background-color: var(--color-btn-spec-hover);
        box-shadow: var(--shadow-spec-button-active);
    }
    
    /* Ensure active state is maintained even on hover */
    .navigation-toggle.active:hover {
        background-color: var(--color-btn-spec-hover);
    }
</style>